export default "__VITE_ASSET__0945b9f8__"